import React from "react";
import ErrorBoundary from "../../Components/Common/ErrorBoundary";
// Add ordinal suffix like 1st, 2nd, 3rd, etc.
const formatOrdinal = (day) => {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
        case 1: return `${day}st`;
        case 2: return `${day}nd`;
        case 3: return `${day}rd`;
        default: return `${day}th`;
    }
};

// Format date and time from ISO string
const formatDateTime = (isoString) => {
    if (!isoString) return { time: "–", date: "–" };

    const dateObj = new Date(isoString);

    // Format time (e.g., 4:30 PM)
    const time = dateObj.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });

    // Format date (e.g., 23rd Jun 2025)
    const day = formatOrdinal(dateObj.getDate());
    const month = dateObj.toLocaleString("en-US", { month: "short" });
    const year = dateObj.getFullYear();

    return {
        time,
        date: `${day} ${month} ${year}`,
    };
};

const OrderHistory = ({ previousorderdata }) => {
    const orderHistory = previousorderdata?.order_history || [];

    return (
        <div style={{ fontSize: 13 }}>

            {orderHistory.length > 0 ? (
                orderHistory.map((ele, index) => {
                    const { time, date } = formatDateTime(ele.statusdate);

                    return (
                        <div
                            key={index}
                            style={{
                                marginBottom: 5,
                                lineHeight: "1.5",
                            }}
                        >
                            {
                                ele.assign_to_names &&
                                <>
                                <span>
                                    Assign to -{ele.assign_to_names}
                                </span>{" "}
                                </>
                            }

                            <span style={{ color: "#2a5bd7", cursor: "pointer" }}>
                                {ele.staff_comments || "N/A"}
                            </span>{" "}
                            by{" "}
                            <span style={{ color: "#2a5bd7", cursor: "pointer" }}>
                                {ele.firstname || "Staff"}
                            </span>{" "}
                            at {time} on {date}
                        </div>
                    );
                })
            ) : (
                <div>No edit history available.</div>
            )}
        </div>
    );
};

export default React.memo(OrderHistory);
